import React from 'react';
import {
  HeroHeaderSkeleton,
  SectionHeaderSkeleton,
  SectionSkeleton,
  StageRailSkeleton,
  TabbedRunsSkeleton
} from './blocks';

const DurableDetailSkeleton: React.FC = () => (
  <>
    <HeroHeaderSkeleton />
    <SectionSkeleton titleWidth={50}>
      <StageRailSkeleton stages={2} />
    </SectionSkeleton>
    <SectionSkeleton titleWidth={0}>
      <SectionHeaderSkeleton />
      <TabbedRunsSkeleton tabs={2} rows={4} />
    </SectionSkeleton>
  </>
);

export default DurableDetailSkeleton;
